import { getAgeDemographic } from '../components/Helpers/dates';

const DEBUG = false;

const isDynatraceEnabled = Boolean(global.dtrum);

const log = (message, ...attributes) => {
  if (!DEBUG) return;
  // eslint-disable-next-line no-console
  console.log('Analytics ->', message, JSON.stringify(attributes));
};

export const record = async (name, attributesParams) => {
  let user;
  const attributes = { ...attributesParams };

  // TODO fix this when re-enable analytics
  /*
  try {
    user = await Auth.currentAuthenticatedUser();
  } catch (ignore) {}
  */

  if (user && user.username) {
    attributes['Cognito User'] = user.username;
  }

  if (user && user.attributes && user.attributes.birthdate) {
    const ageDemographic = getAgeDemographic(user.attributes.birthdate);
    attributes['Age Demographic'] = ageDemographic;
  }

  log('record', name, { attributes });

  if (isDynatraceEnabled) {
    global.dtrum.enterAction(name, null, null, JSON.stringify(attributes));
  }
};

export const identifyUser = async () => {
  if (!isDynatraceEnabled) return;

  let user;

  // TODO fix this when re-enable analytics
  /*
  try {
    user = await Auth.currentAuthenticatedUser();
  } catch (ignore) {}
  */

  if (!user || !user.username) return;
  global.dtrum.identifyUser(user.username);
};

export const identifyUserWithReference = async (userReference) => {
  if (!isDynatraceEnabled) return;

  if (!userReference) return;
  global.dtrum.identifyUser(userReference);
};

export const sendSessionProperties = async (attributes = {}) => {
  if (!isDynatraceEnabled) return;

  global.dtrum.sendSessionProperties(null, null, attributes);
};

export const endSession = async () => {
  if (!isDynatraceEnabled) return;

  global.dtrum.endSession();
};
